import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  finishTraining,
  getTrainingSlots,
  trainBodyguard,
} from "@/helper/contractFunctions/MafiaTraning";
import { TrainingSlotType } from "@/types/TrainingSlotType";

export interface TrainingState {
  trainingSlots: TrainingSlotType[];
  isConfirmingTrain: boolean;
  isFinishingTrain: boolean;
}

const initialState: TrainingState = {
  trainingSlots: [
    {
      endTime: 0,
      isTraining: false,
      newCategoryId: 0,
      newTypeId: 0,
      oldItemId: 0,
      startTime: 0,
      trainingCost: 0,
    },
    {
      endTime: 0,
      isTraining: false,
      newCategoryId: 0,
      newTypeId: 0,
      oldItemId: 0,
      startTime: 0,
      trainingCost: 0,
    },
  ],

  isConfirmingTrain: false,
  isFinishingTrain: false,
};

export const getTrainingSlotsAction = createAsyncThunk(
  "training/getTrainingSlotsAction",
  async (account: string) => {
    const trainingSlots = await getTrainingSlots(account);
    return trainingSlots;
  }
);

export const trainBodyguardAction = createAsyncThunk(
  "training/trainBodyguardAction",
  async ({
    account,
    slotId,
    itemId,
  }: {
    account: string;
    slotId: number;
    itemId: number;
  }) => {
    const result = await trainBodyguard(account, slotId, itemId);
    return result.transactionHash || "";
  }
);

export const finishTrainingAction = createAsyncThunk(
  "training/finishTrainingAction",
  async ({ account, slotId }: { account: string; slotId: number }) => {
    const result = await finishTraining(account, slotId);
    return result.transactionHash || "";
  }
);

export const trainingSlice = createSlice({
  name: "training",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTrainingSlotsAction.pending, (state) => {});
    builder.addCase(getTrainingSlotsAction.fulfilled, (state, { payload }) => {
      state.trainingSlots = payload as TrainingSlotType[];
    });
    builder.addCase(getTrainingSlotsAction.rejected, (state) => {});

    builder.addCase(trainBodyguardAction.pending, (state) => {
      state.isConfirmingTrain = true;
    });
    builder.addCase(trainBodyguardAction.fulfilled, (state) => {
      state.isConfirmingTrain = false;
    });
    builder.addCase(trainBodyguardAction.rejected, (state) => {
      state.isConfirmingTrain = false;
    });

    builder.addCase(finishTrainingAction.pending, (state) => {
      state.isFinishingTrain = true;
    });
    builder.addCase(finishTrainingAction.fulfilled, (state) => {
      state.isFinishingTrain = false;
    });
    builder.addCase(finishTrainingAction.rejected, (state) => {
      state.isFinishingTrain = false;
    });
  },
});

export default trainingSlice.reducer;
